import cc from "classcat"
import { ReactComponent as Icon } from "../svg/avatar.svg"

interface Props {
  alt?: string
  className?: string
  description?: string
  href?: string
  label: string
  size?: "large"
  src?: string
  variant?: "light"
}

export const Avatar = ({
  alt,
  className,
  description,
  href,
  label,
  size,
  src,
  variant,
}: Props) => {
  const Tag = href ? "a" : "div"

  const modifiers = {
    container: {
      [`avatar--${variant}`]: variant,
      [`avatar--${size}`]: size,
    },
    image: {
      [`avatar__image--${variant}`]: variant,
      [`avatar__image--${size}`]: size,
    },
    icon: {
      [`avatar__icon--${variant}`]: variant,
      [`avatar__icon--${size}`]: size,
    },
    label: {
      [`avatar__label--${variant}`]: variant,
      [`avatar__label--${size}`]: size,
    },
    description: {
      [`avatar__description--${variant}`]: variant,
      [`avatar__description--${size}`]: size,
    },
  }

  return (
    <Tag className={cc(["avatar", className, modifiers.container])}>
      {src ? (
        <img
          className={cc(["avatar__image", modifiers.image])}
          src={src}
          alt={alt}
        />
      ) : (
        <Icon
          className={cc(["avatar__icon", modifiers.icon])}
          aria-hidden="true"
        />
      )}

      <div className={cc(["avatar__label", modifiers.label])}>
        {label}

        {description && (
          <span
            className={cc([
              "avatar__description",
              className,
              modifiers.description,
            ])}
          >
            {description}
          </span>
        )}
      </div>
    </Tag>
  )
}
